export { DamageMeter, } from "./DamageMeter";
export { TrackerModal, TrackerModalType, } from "./TrackerModal";
export { HelpModal, HelpModalType, } from "./HelpModal";
export { Tracker, TrackerType } from "./Tracker";
export * as Icons from "./Icons";

export enum DamageType {
    None = "none",
    Superficial = "superficial",
    Aggravated = "aggravated",
};

export enum DamageStatus {
    None = "none",
    Wounded = "wounded",
    Impaired = "impaired",
    Incapacitated = "incapacitated",
};

export const getFilledArray = (length: number, filler?: any): any[] => {
    return Array(length).fill(filler || undefined);
};
